import { Flex, Layout, Menu } from 'antd'
import { useMemo, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import { LogoIcon, LogoText } from 'src/assets'
import { useNavigationItems } from 'src/hooks'
import { Content, Footer, Sider } from 'src/layouts'
import { findMatchingMenuKey } from 'src/utils/findMatchingMenuKey'

import { Header } from '..'

import { useStyles } from './styles'

export const DashboardLayout = () => {
  const { styles } = useStyles()
  const [isCollapsed, setIsCollapsed] = useState(false)
  const navigationMenuItems = useNavigationItems()

  const { pathname } = useLocation()

  const selectedKey = useMemo(() => {
    return findMatchingMenuKey(pathname, navigationMenuItems) || ''
  }, [pathname, navigationMenuItems])

  const onToggle = () => setIsCollapsed((prev) => !prev)

  return (
    <Layout className={styles.layout}>
      <Sider isCollapsed={isCollapsed}>
        <Flex className={styles.logo} gap={7} align="center">
          <LogoIcon className={styles.logoIcon} />

          {!isCollapsed && <LogoText />}
        </Flex>

        <Menu
          mode="inline"
          items={navigationMenuItems}
          selectedKeys={[selectedKey]}
        />
      </Sider>

      <Layout>
        <Header onToggle={onToggle} isCollapsed={isCollapsed} />

        <Content>
          <Outlet />
        </Content>

        <Footer>Copyright © {new Date().getFullYear()} | SIME-HIV</Footer>
      </Layout>
    </Layout>
  )
}
